<template>
  <div class="device-ct">
    <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
    <div class="nav">
      <div class="module-title">
        <h1>MRI性能检测虚拟仿真系统</h1>
      </div>

      <div class="ct-content">
        <!-- 文字在上，图片垂直在下 单栏布局 -->
        <div class="single-col-card">
          <div class="text-wrap">
            <p class="text-content">{{ p[0] }}</p>
          </div>
          <!-- 全景大图 -->
          <div class="main-banner">
            <img
              :src="wWidth < 768 ? img[1] : img[0]"
              alt="MRI性能检测虚拟仿真系统，磁共振SMR170模体质控虚拟实训平台"
              class="banner-img"
              loading="lazy"
              decoding="async"
            />
            <div class="banner-glow"></div>
          </div>
          <!-- 多场景图片组件 -->
          <ImgCol :imgList="img.slice(2)" class="step-list" />
        </div>

        <!-- 行业参考标准区块 -->
        <div class="standard-block">
            <div class="refer-text">
              参考标准：中华人民共和国卫生行业标准   WS/T 263-2006  《医用磁共振成像 (MRI) 设备影像质量检测与评价规范》 等
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgCol from "@/components/imgCol.vue";
import PullDown from "@/components/home/pullDown.vue"

export default {
  props: {
    hidePullDown: {
      type: Boolean,
      default: false // 默认显示
    }
  },
  name: "CheckMRIPerformance",
  components: {
    ImgCol,
    PullDown
  },
  data() {
    return {
      wWidth: window.innerWidth,
      p: [
        "配套教材《医学影像设备学》，本系统构建MRI设备及SMR170模体仿真模型和虚拟场景（含磁体间、操作间、模体结构展示），对SMR170模体结构和主要元件实现1:1仿真再现、细致拆解。实现MRI设备性能检测项目标准程序的虚拟仿真教学，可进行模体摆位、模体灌注及空间分辨力、层厚等检测项目，破解高校MRI质控实训条件不足、模体稀缺、真机检测实训难以常态化开展的难题，无磁体安全风险，支持反复演练。引导学生系统掌握磁共振质量控制规范，建立标准化、规范化设备质控思维。"
      ],
      img: [
        require("@/assets/pMRI_last.png"),
        require("@/assets/phone/pmriGrid.png"),
        require("@/assets/pMRI1.png"),
        require("@/assets/pMRI2.png"),
        require("@/assets/pMRI3.png"),
        require("@/assets/pMRI4.png"),
        require("@/assets/pMRI5.png"),
        require("@/assets/pMRI6.png"),
        require("@/assets/pMRI7.png"),
        require("@/assets/pMRI8.png"),
        require("@/assets/pMRI9.png")
      ]
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wWidth = window.innerWidth;
    }
  }
};
</script>

<style lang="scss" scoped>
.device-ct {
  width: 100%;
  padding: 1rem;
  margin-top: 80px;
  background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
  box-sizing: border-box;

  @media (max-width: 767px) {
    margin-top: 60px;
    padding: 0.5rem;
  }

  .nav {
    width: 60%;
    margin: 0 auto;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
                0 8px 24px rgba(37, 75, 156, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    margin-top: 20px;

    @media (max-width: 1024px) {
      width: 80%;
    }
    @media (max-width: 767px) {
      width: 100%;
      border-radius: 16px;
      box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
    }

    &:hover {
      box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
    }
  }

  .module-title {
    padding: 2.5rem 2rem 1.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a365d;
    text-align: center;
    letter-spacing: 0.04em;
    position: relative;
    background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    h1 {
      margin: 0;
      font-size: inherit;
      font-weight: inherit;
    }

    @media (max-width: 767px) {
      font-size: 1.25rem;
      padding: 1.5rem 1rem 1rem;
      gap: 8px;
    }

    &::after {
      content: "";
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .ct-content {
    padding: 2.5rem 3rem 3rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 48px;

    @media (max-width: 1024px) {
      padding: 2rem 2rem 2.5rem;
      gap: 36px;
    }
    @media (max-width: 767px) {
      padding: 1.5rem 1rem 1.5rem;
      gap: 28px;
    }
  }

  .single-col-card {
    background: #fff;
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    margin: auto;
  }

  // 全局统一标准文字样式（与CT/DR完全一致）
  .text-content {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 0.95rem;
    line-height: 2;
    color: #1e293b;
    text-align: justify;
    letter-spacing: 0.01em;
    position: relative;
    padding-left: 1rem;
    border-left: 3px solid transparent;

    @media (max-width: 767px) {
      font-size: 0.85rem;
      line-height: 1.85;
      padding-left: 0.75rem;
    }

    &:first-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(59, 130, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }

    &:last-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(139, 92, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }
  }

  // 全景大图样式统一复用CT页面
  .main-banner {
    position: relative;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 8px 30px rgba(26, 75, 140, 0.12);
  }
  .banner-img {
    width: 95%;
    padding: 10px 0;
    margin: 0 auto;
    display: block;
    transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  .main-banner:hover .banner-img {
    transform: scale(1.035);
  }
  .banner-glow {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 45%;
    background: linear-gradient(to top, rgba(26, 75, 140, 0.22), transparent);
    pointer-events: none;
  }

  .block-title {
    font-size: 22px;
    font-weight: 600;
    color: #1a3b66;
    text-align: center;
    margin: 0 0 24px;
  }

  // 参考标准卡片 与CT/DR视觉统一
  .book-card {
    background-color: #f0f7ff;
    border-radius: 12px;
    padding: 32px 24px;
    text-align: left;
  }
  .standard-card {
    border-left: 5px solid #2563AF;
    transition: all 0.3s ease;
  }
  .standard-card:hover {
    border-left-color: #67a6dc;
    box-shadow: 0 0 12px rgba(37, 99, 175, 0.15);
  }
  .refer-text {
    padding: 8px 12px;
    font-size: 14px;
    color: #555;
    line-height: 1.8;
    text-align: left;
  }

  // ImgCol子组件穿透样式统一
  :deep(.imgCom) {
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    margin-bottom: 14px;
  }
  :deep(.imgCom:hover) {
    transform: translateY(-3px);
    box-shadow: 0 10px 26px rgba(10, 40, 70, 0.12);
  }
  :deep(.imgCom img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.4s ease;
  }
  :deep(.imgCom:hover img) {
    transform: scale(1.04);
  }
}

// 暗色模式完整适配（与CT/DR页面逻辑完全同步）
@media (prefers-color-scheme: dark) {
  .device-ct {
    background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

    .nav {
      background: rgba(20, 30, 50, 0.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .module-title {
        color: #93bbfc;
        background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);
        &::after {
          background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
        }
      }

      .ct-content {
        background: #0f1a2e;

        .single-col-card {
          background: #142033;
        }
        .text-content {
          color: #c8d6e8;
          &:first-of-type {
            background: linear-gradient(90deg, rgba(59, 130, 246, 0.08) 0%, transparent 100%);
          }
          &:last-of-type {
            background: linear-gradient(90deg, rgba(139, 92, 246, 0.08) 0%, transparent 100%);
          }
        }
        .block-title {
          color: #93bbfc;
        }
        .book-card {
          background: rgba(37, 99, 175, 0.12);
        }
        .refer-text {
          color: #b0c4de;
        }
        :deep(.imgCom) {
          background: #142033;
        }
      }
    }
  }
}

// 全局导航统一穿透样式
:deep .global-nav[data-v-5e75b752]{
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
  color: #0f3059;
  background: transparent;
}
</style>